export default __webpack_public_path__ + "static/IBMPlexSans-Regular-Latin1-9df11ababf0dd515e6a33a54b8c50ed3.woff";